import { api } from "../../../api/api";
import {
  getFileExtensionFromUrl,
} from "./getFileNameFromUrl";

export const previewFile = async (fileName: string | null) => {
  if (fileName) {
    const res = await api.get(
      "/user/download-file",
      {
        params: { fileKey: fileName },
        responseType: "blob",
      }
    );
    console.log(res);
    const blob = res.data instanceof Blob
      ? res.data
      : new Blob([res.data], { type: res.headers?.["content-type"] || ("application/" + getFileExtensionFromUrl(fileName)) });
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
  }
  return null;
};
